module.exports = __webpack_public_path__ + "static/media/Quam-Icon-Heart.5fe25cce.svg";